import styled from "styled-components";
import successIcon from "../../assets/images/icons/ic_success_blue.svg";
import caretDownIconBlue from "../../assets/images/icons/ic_caret_down_blue.svg";
import editIcon from "../../assets/images/icons/ic_edit.svg";
import editIconBlue from "../../assets/images/icons/ic_edit_blue.svg";
import closeIcon from "../../assets/images/icons/ic_close.svg";
import closeIconBlue from "../../assets/images/icons/ic_close_blue.svg";
import bagIcon from "../../assets/images/icons/ic_bag.svg";
import detailsIcon from "../../assets/images/icons/ic_details.svg";
import shippingicon from "../../assets/images/icons/ic_shipping.svg";
import paymentIcon from "../../assets/images/icons/ic_payment.svg";
import externalIcon from "../../assets/images/icons/ic_arrow_northeast.svg";
import * as Variable from "../../CSSVariables";

export const AccordionStyle = styled.div`
  overflow: hidden;
  &.email-tab {
    &.signedIn {
      ~ .delivery-tab {
        @media only screen and (min-width: ${Variable.desktop}) {
          margin-top: -62px;
        }
      }
    }
  }
  &.shipping-tab {
    @media only screen and (min-width: ${Variable.mobile}) {
      margin-bottom: 4rem;
    }
  }

  &.accordion-open {
    .preview-count,
    .bag-preview-wrapper {
      display: none;
    }
    .tab {
      .tab-label {
        &:hover {
          background: none;
        }
        &.accordionDelivery {
        }
        &.accordionBilling {
          .sameAsDelivery-wrapper {
            display: none;
          }
        }
      }
      .tab-content-wrapper {
        border-bottom: 0;
      }
      .tab-content {
        // max-height: 300vh;
        padding: 0 0 16px;
        opacity: 1;

        .partial {
          margin-top: 1.8rem;

          .ready,
          .dued {
            margin: 0.4rem 0;
          }
          .ready {
            color: ${Variable.japaneseLaurel};
          }
          .dued {
            color: ${Variable.milanoRed};
          }
        }
      }
      .accordion-view-right {
        &.toggle-close {
          background-image: url(${closeIcon});
          background-repeat: no-repeat;
          background-size: contain;
          vertical-align: middle;
          display: inline-block;
          height: 2rem;
          width: 2rem;
          // transition: all 0.1s;

          &:hover {
            background-image: url(${closeIconBlue});
          }
        }
      }
    }
    &.bag-tab {
      .tab-content {
        padding: 0;
      }
    }
    &.billing-tab {
      .tab .tab-label.accordionBilling ~ .tab-content-wrapper {
        padding: 12px 0 24px;
      }
    }
    &.shipping-tab {
      .tab {
        @media only screen and (min-width: ${Variable.tablet}) {
          margin-bottom: 120px;
        }
      }
    }
  }

  .tab {
    width: 100%;
    overflow: hidden;

    .tab-content-wrapper {
      display: flex;
      border-bottom: 1px solid ${Variable.alto};
    }
    .tab-content {
      // max-height: 0;

      color: ${Variable.mineShaft};
      background: white;

      overflow: hidden;
      flex: 2;

      .title {
        margin: 18px 0;
        font-weight: ${Variable.semiBold};
      }
    }
    .tab-label {
      display: block;
      background: none;
      border: 0;
      width: 100%;
      text-align: left;
      position: relative;

      transition: background-color 0.1s ease-in;
      padding: 24px 0;
      color: inherit;

      @media only screen and (min-width: ${Variable.desktop}) {
        display: flex;
      }

      .bag-preview-wrapper {
        margin-top: 2rem;
        .bag-type-wrapper {
          .bag-type {
            &::before {
              height: 1.4rem;
              width: 1.4rem;
              // top: 0;
              top: 48%;
              transform: translateY(-50%);
            }
            font-size: 1.4rem;
          }
          .sub-text {
            font-size: 1.4rem;
            margin-bottom: 1.2rem;
          }
        }
        .bag-preview {
          display: flex;
          padding: 1.4rem 0;
          border-bottom: 1px solid ${Variable.alto};

          > div {
            flex: auto;

            &.left {
              flex: 75%;
            }
            &.right {
              flex: 25%;
              text-align: right;
            }

            .title,
            .totalPrice {
              font-weight: ${Variable.semiBold};
              margin-bottom: 0.6rem;

              &.discounted-preview {
                color: ${Variable.success};
              }
            }
            .type,
            .quantity {
              font-size: 1.4rem;
            }
          }
          .preview-slashed {
            color: ${Variable.scorpion};
            vertical-align: unset;
            text-decoration: line-through;
            font-weight: normal;
            margin-right: 12px;
          }
        }
        > div {
          > div:last-child {
            .bag-preview:last-child {
              border: 0;
            }
          }
        }
        .divider {
          border: 1px solid ${Variable.mystic};
          width: 100%;
          border-bottom: 0;
          border-right: 0;
          border-left: 0;
          height: 1px;
          margin: 2rem 0;
        }
        .show-more {
          font-size: 1.4rem;
          padding: 0;
          margin-top: 1.2rem;
          cursor: pointer;
          border: 0;
          background: none;
          color: ${Variable.scienceBlue};

          &:hover {
            text-decoration: underline;
          }
        }
      }
      &.accordionBag {
        .accordion-view-wrapper {
          position: unset;
          .accordion-view-mid {
            margin-top: 2.4rem;
            @media only screen and (min-width: ${Variable.desktop}) {
              margin-top: 0;
            }
          }
          .accordion-view-right {
            &.show-bag {
              &:hover {
                color: ${Variable.congressBlue};
              }
            }
          }
        }
        ~ .tab-content-wrapper {
          .tab-content {
            > div:last-child {
              border: 0;
            }
          }
        }
      }
      &.accordionEmail {
        padding: 24px 0 0;

        .tab-title {
          margin-bottom: 30px;
        }
        .accordion-view-title {
          font-weight: ${Variable.regular};
          font-size: 1.6rem;
        }
        .input-wrapper {
          @media only screen and (min-width: ${Variable.tablet}) {
            width: 75%;
          }
          @media only screen and (min-width: ${Variable.largeDesktop}) {
            width: 50%;
          }
          label {
            color: ${Variable.scorpion};
            opacity: 1;
          }
          a {
            vertical-align: unset;
          }
        }

        ~ .tab-content-wrapper {
          border: 0;
          .tab-content {
            border: 0;
            padding: 0;
          }
        }
        .success-icon {
          background-image: url(${successIcon});
          background-repeat: no-repeat;
          background-size: contain;
          vertical-align: middle;
          display: inline-block;
          height: 2rem;
          width: 2rem;
          margin-right: 1rem;
        }
        .label-text-top {
          margin-bottom: 0.8rem;
        }
        .label-text-bottom {
          margin-top: 0.8rem;
        }
      }

      &.accordionDelivery {
        padding: 12px 0 12px;

        .accordion-view-wrapper {
          .accordion-view-right {
            top: 0;
          }
        }
        ~ .tab-content-wrapper {
          border: 0;

          .spacer {
            flex: 0;

            @media only screen and (min-width: ${Variable.desktop}) {
              flex: 1;
            }
          }
          .tab-content {
            border: 0;
            flex: 2;

            > div:last-child {
            }
          }
        }
      }
      &.accordionBilling {
        padding: 0;

        .accordion-view-wrapper {
          .accordion-view {
            > div {
              margin: 0;
            }
          }
          .accordion-view-right {
            top: 0;
          }
        }
        ~ .tab-content-wrapper {
          padding: 0 0 24px;

          .spacer {
            flex: 0;

            @media only screen and (min-width: ${Variable.desktop}) {
              flex: 1;
            }
          }
          .tab-content {
            flex: 2;

            > div:last-child {
            }
          }
        }
      }

      &.accordionShipping {
        .accordion-view-wrapper {
          margin-top: 34px;
          @media only screen and (min-width: ${Variable.desktop}) {
            margin-top: 0;
          }

          .accordion-view-right {
            top: 0;
          }
        }
        ~ div {
          .tab-content {
            padding: 0;
          }
        }
      }
      &:focus {
      }

      * {
        vertical-align: middle;
      }
      img {
        margin-right: 12px;
      }
      .tab-title {
        flex: 1;
        font-weight: ${Variable.semiBold};
        font-size: 2.2rem;

        .tab-icon {
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
          vertical-align: middle;
          display: inline-block;
          height: 2rem;
          width: 2rem;
          margin-right: 1rem;
          margin-bottom: 0.3rem;

          &.bag-icon {
            background-image: url(${bagIcon});
          }
          &.email-icon {
            background-image: url(${detailsIcon});
          }
          &.shipping-icon {
            background-image: url(${shippingicon});
          }
          &.payment-icon {
            background-image: url(${paymentIcon});
          }
        }
        .delivery-charges-link {
          font-weight: normal;
          font-size: 1.3rem;
          margin-top: 0.8rem;
          display: block;
          &:after {
            content: "";
            background-image: url(${externalIcon});
            height: 18px;
            width: 18px;
            display: inline-block;
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
            vertical-align: bottom;
            padding-left: 2rem;
          }
          @media only screen and (min-width: ${Variable.desktop}) {
            margin-left: 3rem;
          }
          &:hover {
            text-decoration: underline;
          }
        }
      }
      .accordion-view-wrapper {
        position: relative;
        flex: 2;
      }

      .accordion-view-right {
        cursor: pointer;
        color: ${Variable.scienceBlue};

        position: absolute;
        top: 24px;
        right: 0;
        font-size: 1.3rem;
        font-weight: ${Variable.regular};
        border: 0;
        background: none;
        padding: 0;

        &.toggle-edit {
          background-image: url(${editIcon});
          background-repeat: no-repeat;
          background-size: contain;
          vertical-align: middle;
          display: inline-block;
          height: 2rem;
          width: 2rem;

          &:hover {
            background-image: url(${editIconBlue});
          }
        }

        &:hover {
          text-decoration: underline;
        }
        .toggle-bag {
          background-image: url(${caretDownIconBlue});
          margin-left: 6px;
          margin-right: 0;
          vertical-align: middle;
          height: 1rem;
          width: 1.6rem;
          transition: all 0.1s ease;
          display: inline-block;
          background-repeat: no-repeat;
          vertical-align: middle;
          background-size: contain;
          &.opened {
            transform: rotate(180deg);
          }
        }
        &.shippingPrice-wrapper {
          .shippingPrice {
            cursor: default;
            color: ${Variable.black};
            font-weight: ${Variable.semiBold};
            font-size: 1.8rem;
            margin: 0;
          }
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }
`;

export const DisplayAddressStyle = styled.div`
  margin-bottom: 16px;
  .accordion-view-title {
    margin: 0 0 12px;
    font-size: 1.8rem;
    font-weight: ${Variable.semiBold};
  }
  .accordion-view-text {
    font-size: 1.6rem;
    line-height: 22px;

    p {
      margin: 0.4rem 0;
    }
  }
`;
